import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Mail, Printer, Scissors, Trophy } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <CreditCard className="w-8 h-8" data-id="element-172" />,
    title: 'Realizás tu pago',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: <Mail className="w-8 h-8" data-id="element-173" />,
    title: 'Recibís los archivos en tu email al instante',
    color: 'bg-yellow-100 text-yellow-600'
  }, {
    icon: <Printer className="w-8 h-8" data-id="element-174" />,
    title: 'Imprimís en casa o en cualquier copistería',
    color: 'bg-purple-100 text-purple-600'
  }, {
    icon: <Scissors className="w-8 h-8" data-id="element-175" />,
    title: 'Recortás y pegás las figuritas en el álbum',
    color: 'bg-red-100 text-red-600'
  }, {
    icon: <Trophy className="w-8 h-8" data-id="element-176" />,
    title: '¡Álbum completo y pasión mundialista garantizada!',
    color: 'bg-green-100 text-green-600'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-177">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-179">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-4" data-id="element-180">
            🖨️ ASÍ DE FÁCIL ES USARLO
          </h2>
        </motion.div>

        <div className="relative" data-id="element-181">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-200 -translate-y-1/2 z-0" data-id="element-182"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 relative z-10" data-id="element-183">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex flex-col items-center text-center bg-white p-6 rounded-2xl shadow-sm border border-gray-100 md:bg-transparent md:border-none md:shadow-none md:p-0" data-id="element-184">
                <div className="w-12 h-12 bg-wc-dark text-white rounded-full flex items-center justify-center font-bold text-xl mb-4 z-10 border-4 border-gray-50 md:border-white shadow-md" data-id="element-185">
                  {idx + 1}
                </div>
                <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-4 ${step.color} shadow-sm transform rotate-3 hover:rotate-0 transition-transform`} data-id="element-186">
                  {step.icon}
                </div>
                <p className="font-bold text-gray-800 md:px-2" data-id="element-187">{step.title}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center bg-white p-6 rounded-xl border border-gray-200 shadow-sm max-w-2xl mx-auto" data-id="element-188">
          <p className="text-lg text-gray-700" data-id="element-189">
            El instructivo incluido te explica exactamente cómo hacerlo paso a
            paso, incluso si nunca imprimiste nada así antes.
          </p>
        </motion.div>
      </div>
    </section>;
}